<template>
  <div>
    <div class="top-nav-backgroud">
      <div class="wrap-lg">
        <div style="height: 28px"></div>
        <div class="side-content" style="height: 114px;text-align: center;">
          <div class="side-left">
            <div class="logo" @click="toPage('home')">
              <img src="@/assets/img/logo.png"/>
            </div>
          </div>
          <div class="side-center">
            <div class="hotWord">
              <span>热门搜索：</span>
              <span v-for="(item,index) in commonUtils.getDictPara('hot_word_search')"
                    :label="item.code" :key="item.code" :class="(index%2 ==0) ? '': 'hot'"
                    @click="searchHots(item.name)"
              >{{item.name}}</span>
            </div>
            <el-input
              class="inline-input"
              v-model="searchText"
              placeholder="请输入您要搜索的关键字"
            >
              <el-button slot="append" @click="handleSearch">搜索</el-button>
            </el-input>
          </div>
          <div class="side-right">
            <div class="ads">
              <img :src="leftTopAds.imgUrl"/>
            </div>
          </div>
        </div>
        <div class="side-content" style="height: 37px;">
          <div class="side-left">
            <div class="service-tittle">
              服务类型
            </div>
          </div>
          <div class="side-center">
            <div class="topNav">
              <ul>
                <li>
                  <my-link href="/" style="color: #32A08C;">首页</my-link>
                </li>
                <li>
                  <my-link href="/mall">日化商城</my-link>
                </li>
                <li>
                  <my-link href="/solution">解决方案</my-link>
                </li>
                <li>
                  <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                      资源中心<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="/standard">
                        检验标准
                      </el-dropdown-item>
                      <el-dropdown-item command="/formula">
                        产品配方
                      </el-dropdown-item>
                      <el-dropdown-item command="/laws">
                        法律法规
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </li>
                <li>
                  <my-link href="/news">新闻资讯</my-link>
                </li>
                <li>
                  <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link">
                          关于我们<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="/serviceProject">
                        服务项目
                      </el-dropdown-item>
                      <el-dropdown-item command="/consulting">
                        合作咨询
                      </el-dropdown-item>
                      <el-dropdown-item command="/contactUs">
                        联系我们
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </li>
                <li>
                  <my-link href="/vip">会员专区</my-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="side-right">
          </div>
        </div>
      </div>
    </div>
    <div class="top-divider"></div>
    <div class="wrap-lg">
      <div class="side-content" style="height: 360px;" @mouseleave="hideMenu">
        <!-- 左侧 -->
        <div class="side-left">
          <ul class="left-menu">
            <li @mouseenter="evtSideEnter(index);"
                v-for="(item,index) in serviceItems" :key="item.id"
                :class="(currActiveIndex === index ? 'activeSide':'')">
              <div class="tittle">
                <i :class="'iconfont '+ item.icon"></i>
                <span>{{item.name}}</span>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="desc">{{item.description}}</div>
            </li>
          </ul>
        </div>
        <div v-show="showMenuDiv" class="side-center-right" style="border-left: solid 1px #e0e0e0;">
          <div v-loading="itemLoading">
            <table class="service-table" width="100%">
              <tbody>
              <tr v-for="serviceType in serviceTypes" :key="serviceType.code">
                <td width="80" class="service-type">
                  <span>{{serviceType.name}}</span>
                </td>
                <td class="service">
                     <span v-for="(service) in serviceType.services" :key="service.id">
                       <my-link :href="'/service/detail?sid='+ service.id" :title="service.title">
                         {{service.title}}
                       </my-link>
                     </span>
                </td>
              </tr>
              </tbody>
            </table>
            <ul class="service-li">
              <li v-for="(service) in services" :key="service.id">
                <a :href="'/service/detail?sid='+ service.id">
                  {{service.title}}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!-- 中间轮播 -->
        <div v-show="!showMenuDiv" class="side-center" style="border-left: solid 1px #e0e0e0;" v-loading="bannerLoading">
          <el-carousel height="360px">
            <el-carousel-item v-for="(banner) in banners" :key="banner.id">
              <a v-if="banner.targetUrl" :href="banner.targetUrl" target="_blank">
                <img style="height: 100%;width: 100%;" :src="banner.imgUrl"/>
              </a>
              <img v-if="!banner.targetUrl" style="height: 100%;width: 100%;" :src="banner.imgUrl"/>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 右侧 -->
        <div v-show="!showMenuDiv" class="side-right hot-news"  @mouseenter="hideMenu2" @mouseleave="tzOuter">
          <div class="quick-menu">
            <div>
              <my-link href="/entrust">
                <i class="iconfont icon-tianxie"></i>
                <span>申请委托</span>
              </my-link>
            </div>
            <div>
              <my-link href="/validReport">
                <i class="iconfont icon-yanzheng"></i>
                <span>报告验证</span>
              </my-link>
            </div>
            <div>
              <my-link href="/userCenter/myReport">
                <i class="iconfont icon-chakan"></i>
                <span>报告管理</span>
              </my-link>
            </div>
          </div>
          <el-divider class="margin-divider-15"></el-divider>
          <el-tabs v-model="activeName" class="notice-tabs">
            <el-tab-pane label="通知公告" name="1" @mouseleave="tzOuter" >
              <ul>
                <li v-for="notice in notices" :key="notice.id">
                  <my-link :href="'/news/detail?st=1&sid='+notice.id" :title="notice.title" notRouter>{{notice.title}}</my-link>
                </li>
              </ul>
              <div class="bottom-more">
                <my-link href="/news?st=1" notRouter>查看更多</my-link>
              </div>
            </el-tab-pane>
            <el-tab-pane label="行业公告" name="2">
              <ul>
                <li v-for="industry in industrys" :key="industry.id">
                  <my-link :href="'/news/detail?st=2&sid='+ industry.id" :title="industry.title" notRouter>{{industry.title}}</my-link>
                </li>
              </ul>
              <div class="bottom-more">
                <my-link href="/news?st=2" notRouter>查看更多</my-link>
              </div>
            </el-tab-pane>
            <el-tab-pane label="政策信息" name="3">
              <ul>
                <li v-for="policy in policys" :key="policy.id">
                  <my-link :href="'/news/detail?st=3&sid='+policy.id" :title="policy.title" notRouter>{{policy.title}}</my-link>
                </li>
              </ul>
              <div class="bottom-more">
                <my-link href="/news?st=3" notRouter>查看更多</my-link>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLists } from '@/api/test/testContent'
import { getFirst as industryList } from '@/api/news/industry'
import { getFirst as noticeList } from '@/api/news/notice'
import { getFirst as policyList } from '@/api/news/policy'
import { getLists as adsPicList } from '@/api/ads/adsPics'

export default {
  name: 'topBanner',
  data: function () {
    return {
      serviceTypes: [],
      services: [],
      hotSearch: this.commonUtils.getDictPara('key_word_search'),
      showMenuDiv: false,
      itemLoading: false,
      bannerLoading: false,
      loading: false,
      currActiveIndex: -1,
      searchText: '',
      activeName: '2',
      timer: null,
      noLb: false,
      leftTopAds: {},
      serviceItems: this.commonUtils.getDictPara('service_type'),
      notices: [],
      industrys: [],
      policys: [],
      banners: []
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  mounted () {
    this.serviceItems.forEach(item => {
      let newName = item.name
      if (newName.split('_').length === 2) {
        item.icon = newName.split('_')[0]
        item.name = newName.split('_')[1]
      }
      item.serviceTypes = this.commonUtils.getDictPara(item.code + '_type')
    })
    this.getLists()
    this.initData()

    // 轮播行业公告
    this.$nextTick(function () {
      this.timer = setInterval(this.changeTab, 5000)
    })
  },
  methods: {
    // 轮播行业公告定时器函数
    changeTab () {
      if (!this.noLb) {
        if (this.activeName === '3') {
          this.activeName = '1'
        } else {
          this.activeName = (parseInt(this.activeName) + 1) + ''
        }
      }
    },
    // 离开轮播
    tzOuter () {
      this.noLb = false
    },
    // 进入轮播
    hideMenu2 () {
      this.showMenuDiv = false
      this.currActiveIndex = -1
      this.noLb = true
    },
    querySearch (queryString, cb) {
      var results = queryString ? this.createFilter(queryString) : this.hotSearch
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter (queryString) {
      return this.hotSearch.filter(restaurant => {
        return (restaurant.value.toString().toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      })
    },
    initData: function () {
      this.getNoticeList() // 通知公告
      this.getIndustryList() // 行业公告
      this.getPolicyList() // 法律法规
      this.adsPicList()
      this.adsLeftTopPicList()
      // 初始化数据
    },
    getIndustryList (param) {
      industryList(param).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.industrys = result.bizData
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    },
    getNoticeList (param) {
      noticeList(param).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.notices = result.bizData
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    },
    getPolicyList (param) {
      policyList(param).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.policys = result.bizData
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    },
    adsPicList () {
      let param = {}
      param.categoryCode = '1'
      this.bannerLoading = true
      adsPicList(param).then(res => {
        this.bannerLoading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.banners = result.bizData
        }
      }).catch(ex => {
        this.bannerLoading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    },
    adsLeftTopPicList () {
      let param = {}
      param.categoryCode = '2'
      adsPicList(param).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          if (result.bizData && result.bizData.length > 0) {
            this.leftTopAds = result.bizData[0]
          }
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    },
    getLists () {
      let param = {}
      this.itemLoading = true
      getLists(param).then(res => {
        this.itemLoading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          let dataList = result.bizData
          // 数据封装
          this.serviceItems.forEach(item => {
            if (item.serviceTypes) {
              item.serviceTypes.forEach(sType => {
                sType.services = dataList.filter(ret => {
                  return (ret.infoId === item.code && ret.testType === sType.code)
                })
              })
            } else {
              item.services = dataList.filter(ret => {
                return (ret.infoId === item.code)
              })
            }
          })
        }
      }).catch(ex => {
        this.itemLoading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    },
    evtSideEnter (index) {
      this.serviceTypes = this.serviceItems[index].serviceTypes
      this.services = this.serviceItems[index].services
      this.showMenuDiv = true
      this.currActiveIndex = index
    },
    hideMenu () {
      this.showMenuDiv = false
      this.currActiveIndex = -1
    },
    toPage (path) {
      this.$router.push({
        name: path
      })
    },
    searchHots (strSearch) {
      this.searchText = strSearch
      this.handleSearch()
    },
    handleSearch () {
      if (this.searchText) {
        window.open('/search?sq=' + this.searchText)
      }
    },
    handleCommand (command) {
      this.$router.push({
        path: command
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .top-nav-backgroud {
    height: 178px;
    background: #FFFFFF;
  }

  .logo {
    padding-top: 10px;
    img {
      width: 181px;
      height: 81px;
      vertical-align: middle;
    }
  }

  .search-row {
    height: 114px;
    text-align: center
  }

  .inline-input {
    width: 550px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    background: #32A08C;
    border-radius: 6px;
    border: solid 3px #32A08C;
    margin-top: 15px;
  }

  .nav-row {
    height: 37px;
  }

  .service-tittle {
    background: #32A08C;
    height: 100%;
    width: 100%;
    border-radius: 4px 4px 0px 0px;
    font-size: 16px;
    line-height: 36px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
  }

  .topNav {
    ul {
      margin: 0;
      padding: 0;
    }
    ul li {
      font-weight: 400;
      display: block;
      float: left;
      padding: 0 18px;
      list-style: none;
      cursor: pointer;
      .el-dropdown-link, a {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3A3A3A;
        line-height: 35px;
        text-decoration: none;
        &:hover {
          color: #32A08C;
        }
      }
    }
  }

  .top-main {
    width: 100%;
    height: 360px;
  }

  .bottom-more {
    text-align: center;
    margin-top: 6px;
    line-height: 36px;
    a {
      font-size: 12px;
      color: #3e3e3e;;
      cursor: pointer;
      text-decoration: none;
      &:hover {
        color: #32A08C;
      }
    }
  }

  .side-content {
    width: 100%;
    display: inline-flex;
    background: #FFFFFF;
    .side-left {
      width: 240px;
      height: 100%;
    }
    .side-center {
      width: 738px;
      height: 100%;
    }
    .side-center-right {
      width: 990px;
      height: 100%;
    }
    .side-right {
      width: 252px;
      height: 100%;
    }
  }

  .left-menu {
    margin: 0;
    padding: 0;
    li {
      padding: 7px 15px;
      border-bottom: solid 1px #e0e0e0;
      list-style: none;
      cursor: pointer;
      color: #3E3E3E;;
      background: #ffffff;
      cursor: pointer;
      .tittle {
        font-size: 15px;
        font-weight: bold;
        .iconfont {
          color: #32A08C;
          margin-right: 11px;
        }
        .el-icon-arrow-right {
          color: #32A08C;
          float: right;
        }
      }
      .desc {
        margin-top: 8px;
        font-size: 13px;
      }
    }
  }

  .hot-news {
    height: 100%;
    background-color: #fff;
    border-radius: 0px 0px 4px 0px;
    ul {
      margin: 0;
      padding: 0 15px;
      height: 185px;
      li {
        line-height: 22px;
        text-align: left;
        font-size: 12px;
        margin: 3px 0;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        list-style: inside;
        a {
          color: #3E3E3E;
          text-decoration: none;
          cursor: pointer;
          &:hover {
            font-weight: bold;
          }
        }
      }
    }
  }

  .activeSide {
    color: #ffffff !important;
    background: #27c2b4!important;
    .iconfont {
      color: #ffffff !important;
    }
    .el-icon-arrow-right {
      color: #ffffff !important;
    }
  }

  .hotWord {
    width: 560px;
    margin-left: 70px;
    overflow: hidden;
    font-size: 12px;
    font-style: normal;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9C9C9C;
    span {
      cursor: pointer;
      padding-left: 12px;
    }
    .hot {
      color: #32A08C;
    }
  }

  .service-table {
    width: 100%;
    padding-top: 10px;
    .service-type {
      vertical-align: middle;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      border-right: solid 1px #F2F6FC;
      border-bottom: solid 1px #F2F6FC;
      span{
        line-height: 36px;
      }
    }
    .service {
      border-bottom: solid 1px #F2F6FC;
      min-height: 60px;
      span {
        display: inline-block;
        width: 140px;
        font-size: 14px;
        color: #303133;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 36px;
        a {
          font-size: 14px;
          color: #303133;
          text-decoration: none;
          padding: 0 6px;
          line-height: 36px;
          &:hover {
            font-weight: bold;
          }
        }
      }
    }
  }

  .service-li {
    padding: 5px 25px;
    list-style: none;
    margin: 0;
    a {
      font-size: 14px;
      color: #303133;
      text-decoration: none;
      padding: 0 6px;
      line-height: 36px;
      &:hover {
        font-weight: bold;
      }
    }
  }

  .quick-menu {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #32A08C;
    padding: 5px;
    margin-top: 10px;
    margin-bottom: 5px;
    cursor: pointer;
    text-align: center;
    list-style: none;
    display: flex;
    text-align: center;
    justify-content: space-evenly;
    a {
      text-decoration: none;
      font-size: 12px;
      display: inline-grid;
    }
    i {
      font-size: 20px;
      color: #32A08C;
    }
  }
</style>
